export default __webpack_public_path__ + "static/media/AboutTheNewADRPoster.9e07833e.png";